<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">

</head>

<body>
  <!-- main body -->
  <div class="container white_bg body_min_height" id="main">
    <div class="PageTitle">
      <h2 style="text-align: center;"><b>404 Page Not Found</b></h2>
    </div>


  </div>


</body>

</html>